import moment from 'moment-timezone';

export function msFrom(value: number, unit: 'minutes' | 'hours'): number {
  return unit === 'minutes' ? value * 60_000 : value * 3_600_000;
}

export function formatPeriodDatetime(
  isoString: string,
  timezone?: string,
  // 12-hour clock when true; 24-hour otherwise (incl. 'auto', preserving the
  // pre-preference default for this moment-formatted display).
  hour12?: boolean
): string {
  const m = timezone ? moment.parseZone(isoString).tz(timezone) : moment.parseZone(isoString);
  const abbr = m.format('z');
  const timeToken = hour12 ? 'h:mm A' : 'HH:mm';
  const datetime = m.format(`ddd, MMM D, YYYY [at] ${timeToken}`);
  return `${datetime} (${abbr})`;
}

export function calculateDuration(openIso: string, closeIso: string): string {
  const openMs = moment.parseZone(openIso).valueOf();
  const closeMs = moment.parseZone(closeIso).valueOf();
  const diffMs = closeMs - openMs;

  if (diffMs <= 0) return '0m';

  const totalMinutes = Math.floor(diffMs / 60_000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${minutes}m`;
  }
}

export const deepClean = (value: any): any => {
  if (Array.isArray(value)) {
    return value
      .map(deepClean)
      .filter(
        (v) =>
          v !== undefined &&
          v !== null &&
          !(typeof v === 'string' && v.trim() === '') &&
          !(Array.isArray(v) && v.length === 0) &&
          !(typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0)
      );
  }
  if (value && typeof value === 'object') {
    const out: Record<string, any> = {};
    Object.entries(value).forEach(([k, v]) => {
      const cleaned = deepClean(v);
      if (cleaned !== undefined && cleaned !== null && !(typeof cleaned === 'string' && cleaned.trim() === '')) {
        out[k] = cleaned;
      }
    });
    return out;
  }
  return value;
};
